/* eslint-disable react/prop-types */
import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import Chip from "@material-ui/core/Chip"; // Import Chip component
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import NavPills from "components/NavPills/NavPills.js";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import EventIcon from "@material-ui/icons/Event";
import SettingsIcon from "@material-ui/icons/Settings";

import { DATE_DISPLAY_FORMAT_DETAILED, dayjs } from "utils/time.jsx";

import {
  getData,
  updateData,
  updateHealthMetricsData,
  getHealthMetricsData
} from "services/userDataProvider.js";
import { Input } from "@material-ui/core";
import { MEDIA_ROOT } from "config.js";
import {
  prefersDarkModeMediaQuery,
  darkModeStyleBlocks
} from "assets/jss/material-dashboard-react.jsx";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  infoHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    background: "hsla(0,0%,98%,.85)",
    boxShadow: "0px 0px 1px 0 hsl(0deg 0% 6% / 40%)",
    borderRadius: "20px"
  },
  updateInfo: {
    color: "#2563eb"
  },
  updateInfoLabel: {
    fontWeight: 600
  },
  sectionLabel: {
    color: "#64748b",
    fontWeight: 600
  },
  aboutMeSection: {
    fontStyle: "italic",
    color: "#555",
    backgroundColor: "#f9f9f9",
    padding: "10px",
    borderRadius: "5px"
  },
  traineePrs: {
    marginTop: "20px"
  },
  roleChip: {
    fontWeight: "bold",
    color: "#0f172a"
  },
  roleChipBeginner: {
    backgroundColor: "#dcfce7"
  },
  roleChipAdvisor: {
    backgroundColor: "#dbeafe"
  },
  roleChipAdmin: {
    backgroundColor: "#fef3c7"
  },
  roleChipDefault: {
    backgroundColor: "#e2e8f0"
  },
  [prefersDarkModeMediaQuery]: darkModeStyleBlocks.userProfile
};

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedData: {},
      userHealthMetrics: {},
      isEditingPrs: false, // Track edit mode for PRs
      isEditingRaces: false, // Track edit mode for Races
      settingsData: {
        primary_sport: "",
        hevy_user_id: "",
        hevy_api_key: "",
        garmin_user_id: "",
        garmin_api_key: "",
        final_surge_user_id: "",
        final_surge_api_key: ""
      }
    };
  }

  getInitialSettingsData = userData => {
    const preferences = (userData && userData.preferences) || {};
    const otherData = (userData && userData.other_data) || {};
    const integrationSettings =
      preferences.integration_settings || otherData.integration_settings || {};
    const fallbackUserId = integrationSettings.integration_user_id || "";

    return {
      primary_sport: preferences.primary_sport || "",
      hevy_user_id: integrationSettings.hevy_user_id || fallbackUserId,
      hevy_api_key: integrationSettings.hevy_api_key || "",
      garmin_user_id: integrationSettings.garmin_user_id || fallbackUserId,
      garmin_api_key: integrationSettings.garmin_api_key || "",
      final_surge_user_id:
        integrationSettings.final_surge_user_id || fallbackUserId,
      final_surge_api_key: integrationSettings.final_surge_api_key || ""
    };
  };

  getIntegrationSettingsFromSettingsData = settingsData => ({
    hevy_user_id: settingsData.hevy_user_id || "",
    hevy_api_key: settingsData.hevy_api_key || "",
    garmin_user_id: settingsData.garmin_user_id || "",
    garmin_api_key: settingsData.garmin_api_key || "",
    final_surge_user_id: settingsData.final_surge_user_id || "",
    final_surge_api_key: settingsData.final_surge_api_key || ""
  });

  syncSettingsState = settingsData => {
    const integrationSettings = this.getIntegrationSettingsFromSettingsData(
      settingsData
    );
    const preferences = {
      ...((this.state.updatedData && this.state.updatedData.preferences) || {}),
      ...(this.state.preferences || {}),
      primary_sport: settingsData.primary_sport || "",
      integration_settings: integrationSettings
    };
    const otherData = {
      ...((this.state.updatedData && this.state.updatedData.other_data) || {}),
      ...(this.state.other_data || {}),
      integration_settings: integrationSettings
    };

    this.setState({
      settingsData,
      updatedData: {
        ...this.state.updatedData,
        preferences,
        other_data: otherData
      }
    });
  };

  updateProfile = () => {
    updateData(
      this.props.axios,
      this.props.user.user_id,
      this.state.updatedData
    );
  };

  updateHealthMetrics = () => {
    updateHealthMetricsData(
      this.props.axios,
      this.props.user.user_id,
      this.state.userHealthMetrics
    );
  };

  onFileLoad = e => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      let updatedData = this.state.updatedData;
      updatedData["avatarFile"] = file;
      this.setState({ updatedData: updatedData });
    }
  };

  onChange = name => e => {
    let updatedData = this.state.updatedData;
    updatedData[name] = e.target.value;
    this.setState({ [name]: e.target.value, updatedData: updatedData });
  };

  onHealthMetricChange = name => e => {
    let updatedData = this.state.userHealthMetrics || {};
    updatedData[name] = e.target.value;
    this.setState({ userHealthMetrics: updatedData });
  };

  onSettingsChange = name => e => {
    const value = e.target.value;
    this.syncSettingsState({
      ...this.state.settingsData,
      [name]: value
    });
  };

  onSettingsValueChange = name => value => {
    this.syncSettingsState({
      ...this.state.settingsData,
      [name]: value
    });
  };

  addNewRace = () => {
    const { userHealthMetrics } = this.state;
    const plannedRaces =
      (userHealthMetrics.other_data &&
        userHealthMetrics.other_data.planned_races) ||
      [];
    const newRace = { name: "", date: "", distance: "" }; // Default empty race
    this.setState({
      userHealthMetrics: {
        ...userHealthMetrics,
        other_data: {
          ...userHealthMetrics.other_data,
          planned_races: [...plannedRaces, newRace]
        }
      }
    });
  };

  onRaceChange = (index, field) => e => {
    const { userHealthMetrics } = this.state;
    const plannedRaces =
      (userHealthMetrics.other_data &&
        userHealthMetrics.other_data.planned_races) ||
      [];
    plannedRaces[index][field] = e.target.value;
    this.setState({
      userHealthMetrics: {
        ...userHealthMetrics,
        other_data: {
          ...userHealthMetrics.other_data,
          planned_races: plannedRaces
        }
      }
    });
  };

  deleteRace = index => () => {
    const { userHealthMetrics } = this.state;
    const plannedRaces =
      (userHealthMetrics.other_data &&
        userHealthMetrics.other_data.planned_races) ||
      [];
    plannedRaces.splice(index, 1); // Remove the race at the specified index
    this.setState({
      userHealthMetrics: {
        ...userHealthMetrics,
        other_data: {
          ...userHealthMetrics.other_data,
          planned_races: plannedRaces
        }
      }
    });
  };

  componentDidMount() {
    getData(this.props.axios, this.props.user.user_id).then(data =>
      this.setState({
        ...data,
        settingsData: this.getInitialSettingsData(data)
      })
    );
    getHealthMetricsData(this.props.axios, this.props.user.user_id).then(data =>
      this.setState({ userHealthMetrics: data })
    );
  }

  renderSettings() {
    const { classes } = this.props;
    const { settingsData } = this.state;
    const primarySportOptions = [
      { text: "Not set", value: "" },
      { text: "Runner", value: "running" },
      { text: "Cyclist", value: "cycling" }
    ];

    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Settings</h4>
          <p className={classes.cardCategoryWhite}>
            Manage user ID and API key for each integration app
          </p>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <InputLabel className={classes.sectionLabel}>
                Primary Sport
              </InputLabel>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomSelect
                value={settingsData.primary_sport}
                items={primarySportOptions}
                onChange={this.onSettingsValueChange("primary_sport")}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <InputLabel className={classes.sectionLabel}>Hevy</InputLabel>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Hevy User ID"
                id="hevy_user_id"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: settingsData.hevy_user_id,
                  onChange: this.onSettingsChange("hevy_user_id")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Hevy API Key"
                id="hevy_api_key"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "password",
                  value: settingsData.hevy_api_key,
                  onChange: this.onSettingsChange("hevy_api_key")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <InputLabel
                className={classes.sectionLabel}
                style={{ marginTop: "8px" }}
              >
                Garmin
              </InputLabel>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Garmin User ID"
                id="garmin_user_id"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: settingsData.garmin_user_id,
                  onChange: this.onSettingsChange("garmin_user_id")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Garmin API Key"
                id="garmin_api_key"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "password",
                  value: settingsData.garmin_api_key,
                  onChange: this.onSettingsChange("garmin_api_key")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <InputLabel
                className={classes.sectionLabel}
                style={{ marginTop: "8px" }}
              >
                Final Surge
              </InputLabel>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Final Surge User ID"
                id="final_surge_user_id"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: settingsData.final_surge_user_id,
                  onChange: this.onSettingsChange("final_surge_user_id")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Final Surge API Key"
                id="final_surge_api_key"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "password",
                  value: settingsData.final_surge_api_key,
                  onChange: this.onSettingsChange("final_surge_api_key")
                }}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button color="info" onClick={this.updateProfile}>
            Save Settings
          </Button>
        </CardFooter>
      </Card>
    );
  }

  renderProfileDetails() {
    const { classes } = this.props;
    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Profile details</h4>
          <p className={classes.cardCategoryWhite}>
            Update the profile details
          </p>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Username"
                id="username"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.username,
                  onChange: this.onChange("username")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Email address"
                id="email"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.email,
                  onChange: this.onChange("email")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="First Name"
                id="first_name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.first_name,
                  onChange: this.onChange("first_name")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Last Name"
                id="last_name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.last_name,
                  onChange: this.onChange("last_name")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="City"
                id="city"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.city,
                  onChange: this.onChange("city")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="Country"
                id="country"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.country,
                  onChange: this.onChange("country")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="Postal Code"
                id="postal_code"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.postal_code,
                  onChange: this.onChange("postal_code")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <InputLabel className={classes.sectionLabel}>About me</InputLabel>
              <CustomInput
                labelText={""}
                id="about_me"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.about_me,
                  onChange: this.onChange("about_me"),
                  multiline: true,
                  rows: 5
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <InputLabel className={classes.sectionLabel}>Avatar</InputLabel>
              <Input type="file" onChange={this.onFileLoad} />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button color="info" onClick={this.updateProfile}>
            Update Profile
          </Button>
        </CardFooter>
      </Card>
    );
  }

  renderHealthMetrics() {
    const { classes } = this.props;
    const { userHealthMetrics } = this.state;
    const lastUpdatedTime = userHealthMetrics.updated_at;
    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Health Metrics</h4>
          <p className={classes.cardCategoryWhite}>
            Keep the health metrics updated
          </p>
          {lastUpdatedTime != null && (
            <div style={styles.updateInfo}>
              <label className={classes.updateInfoLabel}>Last update: </label>
              <large>
                {dayjs(lastUpdatedTime).format(DATE_DISPLAY_FORMAT_DETAILED)},{" "}
                {dayjs(lastUpdatedTime).fromNow()}
              </large>
            </div>
          )}
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Age"
                id="Age"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.age,
                  onChange: this.onHealthMetricChange("age")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Weight(KG)"
                id="Weight"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.weight,
                  onChange: this.onHealthMetricChange("weight")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Height(CM)"
                id="Height(CM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.height,
                  onChange: this.onHealthMetricChange("height")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="BMI"
                id="BMI"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.bmi,
                  onChange: this.onHealthMetricChange("bmi")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Resting Heart Rate(BPM)"
                id="Resting Heart Rate(BPM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.resting_heart_rate,
                  onChange: this.onHealthMetricChange("resting_heart_rate")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Max Heart Rate(BPM)"
                id="Max Heart Rate(BPM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.max_heart_rate,
                  onChange: this.onHealthMetricChange("max_heart_rate")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="VO2 Max(ml/kg/min)"
                id="VO2 Max(ml/kg/min)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  disable: true,
                  value: userHealthMetrics.vo2_max,
                  onChange: this.onHealthMetricChange("vo2_max")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Lactate Threshold (BPM)"
                id="Lactate Threshold (BPM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.lactate_threshold,
                  onChange: this.onHealthMetricChange("lactate_threshold")
                }}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button color="info" onClick={this.updateHealthMetrics}>
            Update
          </Button>
        </CardFooter>
      </Card>
    );
  }

  renderTraineePrs() {
    const { userHealthMetrics, isEditingPrs } = this.state;
    const personalBestEfforts =
      (userHealthMetrics &&
        userHealthMetrics.other_data &&
        userHealthMetrics.other_data.personal_best_efforts) ||
      {};
    const distances = [
      { label: "400m", key: "pr_400m", color: "#e3f2fd" },
      { label: "1 Mile", key: "pr_1mile", color: "#fce4ec" },
      { label: "5K", key: "pr_5k", color: "#e8f5e9" },
      { label: "10K", key: "pr_10k", color: "#fff3e0" },
      { label: "Half Marathon", key: "pr_half_marathon", color: "#ede7f6" },
      { label: "Marathon", key: "pr_marathon", color: "#f3e5f5" }
    ];

    return (
      <div>
        <h5>Personal Bests</h5>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "10px",
                  borderBottom: "1px solid #ddd"
                }}
              >
                Distance
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "10px",
                  borderBottom: "1px solid #ddd"
                }}
              >
                Time
              </th>
            </tr>
          </thead>
          <tbody>
            {distances.map(distance => (
              <tr
                key={distance.key}
                style={{ backgroundColor: distance.color }}
              >
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  {distance.label}
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  {isEditingPrs ? (
                    <Input
                      type="text"
                      value={personalBestEfforts[distance.key] || ""}
                      onChange={e => {
                        const updatedEfforts = {
                          ...personalBestEfforts,
                          [distance.key]: e.target.value
                        };
                        this.setState({
                          userHealthMetrics: {
                            ...userHealthMetrics,
                            other_data: {
                              ...userHealthMetrics.other_data,
                              personal_best_efforts: updatedEfforts
                            }
                          }
                        });
                      }}
                      placeholder="Enter time"
                    />
                  ) : (
                    personalBestEfforts[distance.key] || "N/A"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Button
          color={isEditingPrs ? "success" : "info"}
          onClick={() => {
            if (isEditingPrs) {
              this.updateHealthMetrics();
            }
            this.setState({ isEditingPrs: !isEditingPrs });
          }}
          style={{ marginTop: "10px" }}
        >
          {isEditingPrs ? "Save" : "Edit"}
        </Button>
      </div>
    );
  }

  renderPlannedRaces() {
    const { classes } = this.props;
    const { userHealthMetrics, isEditingRaces } = this.state;
    const plannedRaces =
      (userHealthMetrics &&
        userHealthMetrics.other_data &&
        userHealthMetrics.other_data.planned_races) ||
      [];

    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Planned Races</h4>
          <p className={classes.cardCategoryWhite}>
            View and manage your upcoming races
          </p>
        </CardHeader>
        <CardBody>
          {plannedRaces.length > 0 ? (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}
                  >
                    Race Name
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}
                  >
                    Distance
                  </th>
                  {isEditingRaces && (
                    <th
                      style={{
                        textAlign: "left",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      Actions
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {plannedRaces.map((race, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      {isEditingRaces ? (
                        <Input
                          type="text"
                          value={race.name}
                          onChange={this.onRaceChange(index, "name")}
                          placeholder="Race Name"
                        />
                      ) : (
                        race.name || "N/A"
                      )}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      {isEditingRaces ? (
                        <Input
                          type="date"
                          value={race.date}
                          onChange={this.onRaceChange(index, "date")}
                        />
                      ) : (
                        race.date || "N/A"
                      )}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      {isEditingRaces ? (
                        <Input
                          type="text"
                          value={race.distance}
                          onChange={this.onRaceChange(index, "distance")}
                          placeholder="Distance"
                        />
                      ) : (
                        race.distance || "N/A"
                      )}
                    </td>
                    {isEditingRaces && (
                      <td
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid #ddd"
                        }}
                      >
                        <Button
                          color="danger"
                          size="sm"
                          onClick={this.deleteRace(index)}
                        >
                          Delete
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No planned races available.</p>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px"
            }}
          >
            {isEditingRaces && (
              <Button color="info" onClick={this.addNewRace}>
                Add New Race
              </Button>
            )}
            <Button
              color={isEditingRaces ? "success" : "info"}
              onClick={() => {
                if (isEditingRaces) {
                  this.updateHealthMetrics();
                }
                this.setState({ isEditingRaces: !isEditingRaces });
              }}
            >
              {isEditingRaces ? "Save" : "Edit"}
            </Button>
          </div>
        </CardBody>
      </Card>
    );
  }

  renderRoles() {
    const { roles } = this.state;

    const getRoleChipClassName = role => {
      const normalizedRole = (role || "").toString().toLowerCase();
      if (normalizedRole.includes("beginner")) {
        return this.props.classes.roleChipBeginner;
      }
      if (normalizedRole.includes("advisor")) {
        return this.props.classes.roleChipAdvisor;
      }
      if (normalizedRole.includes("admin")) {
        return this.props.classes.roleChipAdmin;
      }
      return this.props.classes.roleChipDefault;
    };

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
        {roles &&
          roles.map((role, index) => (
            <Chip
              key={index}
              label={role}
              className={`${this.props.classes.roleChip} ${getRoleChipClassName(
                role
              )}`}
            />
          ))}
      </div>
    );
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    let availableTabs = [
      {
        tabButton: "Profile",
        tabIcon: AccountCircleIcon,
        tabContent: this.renderProfileDetails()
      },
      {
        tabButton: "Metrics",
        tabIcon: FitnessCenterIcon,
        tabContent: this.renderHealthMetrics()
      },
      {
        tabButton: "Planned Races",
        tabIcon: EventIcon, // Updated icon for Planned Races
        tabContent: this.renderPlannedRaces()
      },
      {
        tabButton: "Settings",
        tabIcon: SettingsIcon,
        tabContent: this.renderSettings()
      }
    ];
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              <CardAvatar profile>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <img src={`${MEDIA_ROOT}${this.state.avatar}`} alt="..." />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h4 className={classes.cardTitle}>
                  {this.state.first_name} {this.state.last_name}
                </h4>
                <div>{this.renderRoles()}</div>
                <p
                  className={`${classes.description} ${classes.aboutMeSection}`}
                >
                  {this.state.about_me}
                </p>
                <div className={classes.traineePrs}>
                  {this.renderTraineePrs()}
                </div>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <NavPills
              color="info"
              vertical={{
                tabsGrid: { xs: 12, sm: 12, md: 12 },
                contentGrid: { xs: 12, sm: 12, md: 12 }
              }}
              tabs={availableTabs}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(UserProfile);
